// extracted by mini-css-extract-plugin
module.exports = {"main":"ServicesRelated_main__0mp1X","lists":"ServicesRelated_lists__hspj4","search-fade-in":"ServicesRelated_search-fade-in__l2rgH"};